import firebase from "firebase/compat/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCzoNuwhBD9XRdN0MIUoNQOvJS8U-SFt40",
  authDomain: "pokerparliament.firebaseapp.com",
  databaseURL: "https://pokerparliament-default-rtdb.firebaseio.com",
  projectId: "pokerparliament",
  storageBucket: "pokerparliament.firebasestorage.app",
  messagingSenderId: "503092611798",
  appId: "1:503092611798:web:b6fc65e0010172a6d61777",
  measurementId: "G-ZZYLB94XDY"
};


const pokerParliament = firebase.initializeApp(firebaseConfig, 'pokerParliament');

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging();
    }
    console.log('SportFirebase not supported this browser');
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();
export const db = getFirestore(pokerParliament);
export const auth = getAuth();
export const functions = getFunctions(getApp());
export const storage = getStorage();
export const assignPokerParliament = httpsCallable(functions, "assignReferrer");
export default pokerParliament;
